/*!

=========================================================
* Paper Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// import ReactDOM from "react-dom/client";
import { createRoot } from 'react-dom/client';
import { Router, Route, Routes, Navigate } from "react-router-dom";
import Sub from "layouts/Sub.jsx";
import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";
import cookie from 'react-cookies';
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.1.0";
import "assets/scss/tabs.scss";
import "assets/demo/demo.css";
import { Provider } from 'react-redux'
import "assets/css/material-style.css";
import ReactRouteAll from './ReactRouteAll';
// import TestApp from './TestApp';

import {store,persistor} from './store/index';

import { PersistGate } from 'redux-persist/integration/react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import "assets/css/designer.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "react-notification-alert/dist/animate.css";
import "react-toastify/dist/ReactToastify.css";

// ─────────────────────────────────────────────────────────────────────────────
// Consolidated CSS imports.
// All stylesheet imports across the app are centralized here so load order is
// deterministic and styles aren't duplicated across route/component bundles.
// Do NOT add `import "*.css"` in individual components — add it below instead.
// ── Third-party / vendor CSS ──
import "react-alice-carousel/lib/alice-carousel.css";
import "react-phone-number-input/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "shepherd.js/dist/css/shepherd.css";
import "react-daypicker/lib/DayPicker.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-vertical-timeline-component/style.min.css";
import "swiper/swiper-bundle.css";
// ── App / assets CSS ──
import "assets/css/business-page.css";
import "assets/css/download-button.css";
import "assets/css/material-style.css";
import "assets/css/mic-setup.css";
import "assets/css/region-access.css";
import "assets/css/mocks-old-design.css";
import "assets/css/pte-responsive.css";
import "assets/css/public-pages.css";
import "assets/css/reorder.css";
import "assets/css/question_responses.css";
import "assets/css/popup.css";
import "assets/css/faq-section.css";
import "assets/css/cta-contact-section.css";
import "assets/css/PteConsultation.css";
import "assets/css/new-result.css";
import "assets/css/video-course-section.css";
import "../public/css/new-app.css";
// ── Component-local CSS ──
import "components/custom.css";
import "components/dropdown.css";
import "components/reorder.css";
import "components/InfiniteDropdown.css";
import "components/Inputs/PhoneInputField.css";
import "components/ToolTip/tooltip.css";
import "components/WebsiteTour/shepherd-custom.css";
import "components/WebsiteTour/tourpopup.css";
import "views/Score.css";
// ── Authoritative app overrides — MUST load last so their rules win the cascade.
// These re-style generic dashboard cards/listings (.card-wrapper, .mock-test,
// .test-result, etc.) and intentionally override base rules like custom.css's
// `.content .card`. Keep them at the END of this block; moving them earlier
// silently breaks listing styling (square corners, lost shadows). ──
import "assets/css/new-custom-style.css";
import "assets/css/r-new-custom-style.css";
import "assets/css/developer-new-custom-style.css";
// ─────────────────────────────────────────────────────────────────────────────

import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { SidebarProvider } from "./context/SidebarContext";

// ✅ Install media interceptors to auto-register all getUserMedia and AudioContext.
import { installMediaInterceptors } from './util/mediaInterceptor';
import { captureUtmParams } from './util/utmTracker';
import { installEssayTooltipPositioner } from './util/essayTooltipPositioner';

// Defense in depth: boot-time side effects must NEVER throw before React mounts.
// Headless crawlers (Prerender.io) lack browser APIs these touch; an uncaught throw
// here leaves #root empty and gets snapshotted as a blank page.
try {
  installMediaInterceptors();
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('installMediaInterceptors failed:', e);
}

try {
  captureUtmParams();
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('captureUtmParams failed:', e);
}

try {
  installEssayTooltipPositioner();
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('installEssayTooltipPositioner failed:', e);
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
		<Provider store = {store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
				 <SidebarProvider>
				{/* <TestApp /> */}
				<ReactRouteAll/>
        <ToastContainer
          position="top-right"
          autoClose={7000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
				 </SidebarProvider>
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</GoogleOAuthProvider>
);
